import { lightColors } from '@/plugins/colors/base/baseColorsLight'

export const controlsTokensLight = {
  'controls-background-inactive-default': lightColors.gray['200'],
  'controls-background-inactive-hover': lightColors.gray['100'],
  'controls-background-active-default': lightColors.brand['500'],
  'controls-background-active-hover': lightColors.brand['300'],
  'controls-background-disabled': lightColors.gray['100'],
  'controls-foreground-default': lightColors.gray.white,
  'controls-foreground-hover': lightColors.gray.white,
  'controls-foreground-active': lightColors.gray.white,
  'controls-foreground-disabled': lightColors.gray['20'],
  'controls-inactive-hover': lightColors.gray['200'],
  'controls-active-hover': lightColors.brand['500'],
  'progress-bar-background-default': lightColors.gray['50'],
  'progress-bar-foreground-default': lightColors.brand['500']
}

export default controlsTokensLight
